const pageKey = 'ACCESSIBILITY';

export const ACCESSIBILITY_CONTENT = {
  title: `${pageKey}.TITLE`
};
